import { useInitializeDocumentInfo, useInitializeDocumentTypes, useInitializeDocumentUsers } from './hooks'
import { useAppDispatch } from '../../../store/hooks'
import { useEffect } from 'react'
import { resetDocumentSummary } from '../../../store/processDocument/documentSummary'
import { useParams } from 'react-router-dom'
import { setProcessEmailAttachmentAttachmentId, setProcessEmailAttachmentEmailId } from '../../../store/processDocument/emailAttachmentInfo'

export const AttachmentSummaryInitialization = () => {
  useInitializeAttachmentSummary()
  useInitializeAttachmentSummaryParams()
  useInitializeDocumentInfo()
  useInitializeDocumentTypes()
  useInitializeDocumentUsers()

  return null
}

const useInitializeAttachmentSummary = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(resetDocumentSummary())
    }
  }, [dispatch])
}

const useInitializeAttachmentSummaryParams = () => {
  const dispatch = useAppDispatch()

  const { attachmentId = null, emailId = null } = useParams()
  useEffect(() => {
    if (!attachmentId || !emailId) {
      return
    }
    dispatch(setProcessEmailAttachmentAttachmentId(attachmentId))
    dispatch(setProcessEmailAttachmentEmailId(emailId))
  }, [dispatch, attachmentId, emailId])
}
